



















































































































































































































































































































































































import Component, {mixins} from 'vue-class-component';
import {Vue, Watch} from 'vue-property-decorator';
import {HomeIcon, UserIcon, KeyIcon} from 'vue-feather-icons';
import {SignUpDto, checkDuplicateUserIdDto, BizSirenEncodeResponse, BizSirenResultDto} from '@/services/LoginModels';
import {loginService} from '@/services/login.service';
import {MemberInfo, SexType, User, YesOrNo} from '@/models';
import GeneralUtil from '@/util/GeneralUtil';
import FormRequiredInput from '@/components/forms/FormRequiredInput.vue';
import MemberPrivacy from '@/pages/Login/Components/MemberPrivacy.vue';
import MemberMarketingPrivacy from '@/pages/Login/Components/MemberMarketingPrivacy.vue';
import MemberPrivacyConsignment from '@/pages/Login/Components/MemberPrivacyConsignment.vue';
import AdvertisementAgreeJoin from '@/pages/Login/Components/AdvertisementAgreeJoin.vue';
import AgreeCompleteJoin from '@/pages/Login/Components/AgreeCompleteJoin.vue';

declare global {
  interface Window {
    recvSirenPhoneResult: any;
  }
}

interface YourComponentType extends Vue {
  validate(): any;
}

@Component({
  components: {
    HomeIcon,
    UserIcon,
    KeyIcon,
    GeneralUtil,
    FormRequiredInput,
    MemberPrivacy,
    MemberMarketingPrivacy,
    MemberPrivacyConsignment,
    AdvertisementAgreeJoin,
    AgreeCompleteJoin,
  },
})
export default class AuthSignupFinish extends mixins(GeneralUtil) {
  agree1 = false;
  marketingYn = false;
  agree3 = false;
  agree4 = false;
  checkPrivacy = false;
  checkMarketing = false;
  step = 1;
  signUpDto: SignUpDto = {
    guestName: '',
    birthday: '',
    lunarCode: '1',
    sex: 'M',
    userId: '',
    userPasswd: '',
    hpNo: '',
    smsSendYn: 'N',
    email: '',
    emailYn: 'N',
    marketingYn: 'N',
    guestNo: '',
    opinionYn: 'Y',
    prsinClctn01: 'Y',
    prsinClctn02: 'Y',
    prsinClctn03: 'N',
  };
  private passwordRepeat = '';
  private smsSendYn = false;
  private emailYn = false;
  private identityAuth = false;
  private chkDuplicateId = false;
  private hpNoReadonly = false;
  private reqInfo = '';
  private windowRef: any = null;
  private host = window.location.protocol + '//' + window.location.host;
  private chkEmailAuth = false;
  private emailAuthCode = '';
  private sendEmailAuth = false;
  private sendingEmail = false;

  $refs!: {
    observer: YourComponentType;
  };

  @Watch('agree4', {immediate: true, deep: true})
  public agree4Changed(newValue: boolean, oldValue: boolean) {
    if (newValue !== oldValue) {
      this.agree1 = newValue;
      this.marketingYn = newValue;
      this.agree3 = newValue;
    }
  }

  @Watch('checkMarketing', {immediate: true, deep: true})
  public marketingChanged(newValue: boolean, oldValue: boolean) {
    if (newValue !== oldValue) {
      this.checkMarketing = newValue;
    }
  }

  @Watch('signUpDto.userId', {immediate: true, deep: true})
  public userIdChanged(newValue: string, oldValue: string) {
    if (newValue !== oldValue) {
      this.signUpDto.userId = newValue.trim().toLowerCase();
    }
  }

  mounted(): void {
    // eslint-disable-next-line
    window.recvSirenPhoneResult = this.recvSirenPhoneResult;
    this.$store.dispatch('Display/changeName', {name: '고객 정보 입력'});
  }

  cancel(): void {
    this.$router.go(-1);
  }

  chkPrivacy(): void {
    if (!this.agree1) {
      this.showMsgBoxOkPmsErr('개인정보 수집 및 이용 동의서 동의가 필요합니다', '동의필요');
      return;
    }
    if (!this.agree3) {
      this.showMsgBoxOkPmsErr('개인정보의 처리위탁 동의가 필요합니다.', '동의필요');
      return;
    }
    if (!this.checkMarketing) {
      this.checkMarketing = true;
    }

    this.checkPrivacy = true;
  }

  openPhoneAuthPopup(): void {
    //console.log(this.authPhoneDto);

    //핸드폰 본인인증 창열
    const retUrl = this.host + '/noHeader/p/bizSirenCallBackPhone';
    loginService.getBizSirenEncode(retUrl).then(response => {
      if (response.status == 200) {
        const responseData = response.data as BizSirenEncodeResponse;
        this.reqInfo = responseData.reqInfo;
        this.windowRef = window.open(
          '',
          '',
          'width=430, height=560, resizable=1, scrollbars=no, status=0, titlebar=0, toolbar=0, left=300, top=200',
        );
        const popupDocument = this.windowRef.document;
        const frm = popupDocument.createElement('form');
        frm.setAttribute('id', 'auth-form');
        frm.setAttribute('action', 'https://pcc.siren24.com/pcc_V3/jsp/pcc_V3_j10_v4.jsp');
        frm.setAttribute('method', 'post');
        frm.setAttribute('target', '_self');

        const element1 = popupDocument.createElement('input');
        element1.type = 'hidden';
        element1.value = responseData.cryptoTokenId;
        element1.name = 'crypto_token_id';
        frm.appendChild(element1);

        const element2 = popupDocument.createElement('input');
        element2.type = 'hidden';
        element2.value = responseData.integrityValue;
        element2.name = 'integrity_value';
        frm.appendChild(element2);

        const element3 = popupDocument.createElement('input');
        element3.type = 'hidden';
        element3.value = responseData.reqInfo;
        element3.name = 'reqInfo';
        frm.appendChild(element3);

        const element4 = popupDocument.createElement('input');
        element4.type = 'hidden';
        element4.value = responseData.verSion;
        element4.name = 'verSion';
        frm.appendChild(element4);

        popupDocument.body.appendChild(frm);
        //this.windowRef.document.body.appendChild(this.$el);
        //copyStyles(window.document, this.windowRef.document);
        //this.windowRef.addEventListener('beforeunload', this.closePopup);
        frm.submit();
      } else {
        //http response 오류 처리
      }
    });
  }

  recvSirenPhoneResult(type: string, result: BizSirenResultDto): void {
    this.signUpDto.guestName = result.name;
    this.signUpDto.birthday = result.birYMD;
    this.signUpDto.sex = result.sex;
    if (type === 'phone') {
      this.hpNoReadonly = true;
      this.signUpDto.hpNo = result.cellNo;

      const user: User = {
        hpNo: this.signUpDto.hpNo,
        guestName: this.signUpDto.guestName,
        guestNo: '', //	고객번호
        smsSendYn: 'Y', //	sms수신여부 (Y/N)
        email: '', //	이메일주소
        emailYn: '', //	이메일수신여부 (Y/N)
        sex: 'M', //	성별 (M/F)
        birthday: '', //	생년월일
        lunarCode: '', //	음/양 구분 (1 양력 /2 음력)
        joinDate: '', //	가입일자
        areaType: '', //	지역코드
        areaTypeName: '', //	지역명
        snsType: '', //	SNS구분
        snsId: '', //	SNS토큰
        memInfoArr: [],
        snsToken: '',
        homepageGrade: '',
        homepageGradeName: '', //홈페이지 등급이름 (Classic, Premiere)
        marketingYn: 'N',
        opinionYn: 'Y',
        prsinClctn01: 'N',
        prsinClctn02: 'N',
        prsinClctn03: 'N',
        marketingChk: 'N',
      };
      //회원가입 중복확인
      loginService
        .userIdFind(user)
        .then(response => {
          if (response.status == 200) {
            const responseData = response.data;
            if (responseData.resultCode == '0000') {
              this.$bvModal
                .msgBoxOk('이미 가입된 정보입니다', {
                  title: '중복가입',
                  okVariant: 'danger',
                  centered: true,
                })
                .then(value => {
                  this.$router.push('/p/login');
                });
            } else if (responseData.resultCode == '3000') {
              //guestNo가 있으면 설정
              if (responseData.obj.guestNo != '') {
                if (responseData.obj.guestNo) {
                  this.signUpDto.guestNo = responseData.obj.guestNo;
                } else {
                  this.signUpDto.guestNo = '';
                }
              }
              //this.showMsgBoxOkPmsErr(responseData.msg, '인증완료');
              this.identityAuth = true;
            }
          } else {
            //http response 오류 처리
            this.identityAuth = false;
          }
        })
        .catch(error => {
          console.log(error.response);
          //window.opener.recvKakaoResult(error.response);
          this.$bvModal.msgBoxOk(error.response.data, {
            title: '아이디 검색실패',
            centered: true,
          });
          this.identityAuth = false;
        });
    }
  }

  // userCheck(): void {
  //   loginService.userJoin(this.signUpDto).then(response => {
  //     if (response.status == 200) {
  //       const responseData = response.data;
  //       if (responseData.resultCode == '0000') {
  //         //로그인 성공 mypage로 이동
  //         console.log('회원가입 성공 Home으로 이동');
  //         this.$bvModal
  //           .msgBoxOk('Home으로 이동', {
  //             title: '회원가입 성공',
  //             okVariant: 'success',
  //             centered: true,
  //           })
  //           .then(value => {
  //             this.$router.push('/');
  //           });
  //       } else {
  //         //PMS 로그인 에러처리 필요
  //         this.showMsgBoxOkPmsErr(responseData.msg, '회원가입 실패').then(value => {
  //           this.chkDuplicateId = false;
  //         });
  //       }
  //     } else {
  //       //http response 오류 처리
  //     }
  //   });
  // }

  openIpinAuthPopup(): void {
    console.log('auth attempt');
    //console.log(this.authPhoneDto);

    //핸드폰 본인인증 창열
    loginService.getBizSirenEncodeIpin().then(response => {
      if (response.status == 200) {
        const responseData = response.data;
        this.reqInfo = responseData;
        //console.log(responseData);
        this.windowRef = window.open(
          '',
          '',
          'width=430, height=560, resizable=1, scrollbars=no, status=0, titlebar=0, toolbar=0, left=300, top=200',
        );
        const popupDocument = this.windowRef.document;
        const frm = popupDocument.createElement('form');
        frm.setAttribute('id', 'auth-form');
        frm.setAttribute('action', 'https://ipin.siren24.com/i-PIN/jsp/ipin_j10.jsp');
        frm.setAttribute('method', 'post');
        frm.setAttribute('target', '_self');

        const element1 = popupDocument.createElement('input');
        element1.type = 'hidden';
        element1.value = this.reqInfo;
        element1.name = 'reqInfo';
        frm.appendChild(element1);

        const element2 = popupDocument.createElement('input');
        element2.type = 'hidden';
        element2.value = '23' + this.host + '/noHeader/p/bizSirenCallBackIpin';
        element2.name = 'retUrl';
        frm.appendChild(element2);

        const element3 = popupDocument.createElement('input');
        element3.type = 'hidden';
        element3.value = '2';
        element3.name = 'verSion';
        frm.appendChild(element3);

        popupDocument.body.appendChild(frm);
        frm.submit();
      } else {
        //http response 오류 처리
      }
    });
  }

  checkDuplicateId(): void {
    const userId = this.signUpDto.userId;
    if (userId === '') {
      this.$bvModal.msgBoxOk('아이디를 입력하세요', {
        title: '오류발생',
        okVariant: 'danger',
        centered: true,
      });
      return;
    } else {
      const userIdDto: checkDuplicateUserIdDto = {
        userId: userId,
      };
      loginService.checkDuplicateId(userIdDto).then(response => {
        if (response.status == 200) {
          const responseData = response.data;
          if (responseData.resultCode == '0000') {
            this.$bvModal
              .msgBoxOk('아이디사용가능', {
                title: '성공',
                okVariant: 'success',
                centered: true,
              })
              .then(value => {
                this.chkDuplicateId = true;
              });
          } else {
            this.$bvModal
              .msgBoxOk('중복된아이디 있음', {
                title: '오류발생',
                okVariant: 'danger',
                centered: true,
              })
              .then(value => {
                this.chkDuplicateId = false;
              });
          }
        } else {
          //http response 오류 처리
        }
      });
    }
  }

  signUp(): void {
    if (this.marketingYn) {
      this.signUpDto.marketingYn = 'Y';
    } else {
      this.signUpDto.marketingYn = 'N';
    }
    if (this.smsSendYn) {
      this.signUpDto.smsSendYn = 'Y';
    } else {
      this.signUpDto.smsSendYn = 'N';
    }
    loginService.userJoin(this.signUpDto).then(response => {
      if (response.status == 200) {
        const responseData = response.data;
        if (responseData.resultCode == '0000') {
          //로그인 성공 mypage로 이동
          console.log('회원가입 성공 Home으로 이동');
          this.$bvModal
            .msgBoxOk('Home으로 이동', {
              title: '회원가입 성공',
              okVariant: 'success',
              centered: true,
            })
            .then(value => {
              this.$router.push('/');
            });
        } else {
          //PMS 로그인 에러처리 필요
          this.$bvModal
            .msgBoxOk(responseData.msg, {
              title: '회원가입 실패',
              okVariant: 'danger',
              centered: true,
            })
            .then(value => {
              this.chkDuplicateId = false;
            });
        }
      } else {
        //http response 오류 처리
      }
    });
  }

  async onSignUpSubmit(): Promise<void> {
    if (!this.identityAuth) {
      await this.$bvModal.msgBoxOk('본인인증이 필요합니다', {
        title: '본인인증증필요',
      });
      return;
    }

    const isValid = await this.$refs.observer.validate();
    if (!isValid) {
      await this.$bvModal.msgBoxOk('모든 필드가 입력되지 않았습니다.', {
        title: '필수필드 입력필요',
      });
      return;
    }

    if (this.passwordRepeat != this.signUpDto.userPasswd) {
      await this.$bvModal.msgBoxOk('패스워드가 일치하지 않습니다', {
        title: '비밀번호 확인필요',
        okVariant: 'danger',
      });
      return;
    }
    if (this.smsSendYn) {
      this.signUpDto.smsSendYn = 'Y';
    }
    // if (this.emailYn) {
    //   this.signUpDto.emailYn = 'Y';
    // }
    if (this.marketingYn) {
      this.signUpDto.marketingYn = 'Y';
    }
    if (this.signUpDto.email !== '' && !this.chkEmailAuth) {
      await this.$bvModal.msgBoxOk('이메일주소를 인증해주세요', {
        title: '이메일 인증필요',
        okVariant: 'danger',
      });
      return;
    }
    // 중복확인
    if (!this.chkDuplicateId) {
      await this.$bvModal.msgBoxOk('중복 아이디 체크를 해주세요', {
        title: '중복아이디',
        okVariant: 'danger',
      });
      return;
    }
    //이메일 주소 인증코드 확인필요
    //성별, 음력, 양력 코드확인필요
    //인증번호 컨트롤 표시
    //this.$bvModal.show('signup_confirm');
    if (this.marketingYn) {
      this.step = 2;
    } else {
      this.step = 3;
    }
  }

  saveInfo(): void {
    this.step = 3;
  }

  resetEmail(): void {
    this.chkEmailAuth = false;
    this.sendEmailAuth = false;
    this.emailAuthCode = '';
    this.signUpDto.email = '';
  }

  sendEmailAuthCode(): void {
    const userId = this.signUpDto.email;
    if (userId === '') {
      this.$bvModal.msgBoxOk('이메일 입력하세요', {
        title: '이메일주소 입력필요',
        okVariant: 'danger',
        centered: true,
      });
      return;
    } else {
      const userIdDto: checkDuplicateUserIdDto = {
        userId: userId,
      };
      this.sendingEmail = true;
      loginService
        .sendEmailAuthCode(this.signUpDto.email)
        .then(response => {
          if (response.status == 200) {
            this.$bvModal.msgBoxOk('이메일 발송성공 이메일에서 인증코드를 확인후 입력해주세요', {
              title: '성공',
              okVariant: 'success',
              centered: true,
            });
            this.chkEmailAuth = false;
            this.sendEmailAuth = true;
          } else {
            this.$bvModal
              .msgBoxOk('이메일 발송실패', {
                title: '오류발생',
                okVariant: 'danger',
                centered: true,
              })
              .then(value => {
                this.chkEmailAuth = false;
              });
          }
        })
        .finally(() => {
          this.sendingEmail = false;
        });
    }
  }

  async checkEmailAuthCode(): Promise<void> {
    if (this.signUpDto.email === '') {
      this.$bvModal.msgBoxOk('이메일주소를 입력하세요', {
        title: '이메일주소 입력필요',
        okVariant: 'danger',
        centered: true,
      });
      return;
    }
    if (this.emailAuthCode === '') {
      this.$bvModal.msgBoxOk('인증코드를 입력하세요', {
        title: '인증코드입력필요',
        okVariant: 'danger',
        centered: true,
      });
      return;
    }
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const popupTitle = '이메일 인증';
    let errorMessage = '';
    await loginService
      .checkEmailAuthCode(this.emailAuthCode)
      .then(response => {
        this.$bvModal
          .msgBoxOk(`${popupTitle} 성공`, {
            title: '성공',
            okVariant: 'success',
            centered: true,
          })
          .then(value => {
            this.chkEmailAuth = true;
          });
      })
      .catch(function (error) {
        if (error.response) {
          if (error.response.status === 404) {
            errorMessage = '인증번호가 일치하지 않습니다.';
          } else if (error.response.status === 409) {
            errorMessage = "만료된 인증번호입니다. <br>재시도 하시려면 '인증번호 받기'를 눌러주세요.";
          } else {
            errorMessage = `${popupTitle} 서버 오류발생`;
          }
        } else if (error.request) {
          errorMessage = `${popupTitle} 요청 오류발생`;
        } else {
          // 오류를 발생시킨 요청을 설정하는 중에 문제가 발생했습니다.
          errorMessage = `${popupTitle} 요청 오류발생`;
          console.log('Error', error.message);
        }
        //console.log(error.config);
        self.$bvModal.msgBoxOk(self.htmlToVNode(errorMessage), {
          title: `${popupTitle} 오류발생`,
          okVariant: 'danger',
          centered: true,
        });
        self.chkEmailAuth = false;
      })
      .finally(() => {
        self.hideLoadingModal();
      });
  }

  removeEventSpaces(e: any): void {
    e.preventDefault();
    const left = e.target.value.substring(0, e.target.selectionStart);
    const right = e.target.value.substring(e.target.selectionEnd, e.target.value.length);
    const pasted = (e.dataTransfer || e.clipboardData).getData('text').replace(/ /g, '');
    e.target.value = left + pasted + right;
  }
}
